/**
 * 多语言
 * */
import Setting from '../../../../setting';
import util from '../../../../libs/util';
import { pathInit } from '../../../../store/modules/admin/modules/db';
import i18nTextApi from '../../../../api/i18nText';
// import i18n from '../../../../i18n';

const savedLocaleKey = 'i18n-locale';

export default {
  namespaced: true,
  state: {
    locale: '',
    languages: {}
  },
  actions: {
    /**
     * @description 设置当前语言
     * */
    setLocale({ state }, { locale = Setting.i18n.default, vm }) {
      const db = util.db.get(
        pathInit({
          dbName: 'database',
          path: '',
          user: false,
          defaultValue: {}
        })
      );

      // 将语言保存在本地
      db.set(savedLocaleKey, locale).write();

      // 设置当前语言
      state.locale = locale;
      // 设置 vue-i18n 的语言
      vm.$i18n.locale = locale;
      // 更新网页标题
      util.title({
        title: vm.$route.meta.title
      });
    },
    /**
     * @description 加载语言
     * @param {Object} state vuex state
     */
    async load({ state }, vue) {
      let locale;

      const db = util.db.get(
        pathInit({
          dbName: 'database',
          path: '',
          user: false,
          defaultValue: {}
        })
      );

      const savedLocale = db.get(savedLocaleKey).value();

      // 先判断本地存储是否已有语言选择
      if (savedLocale) {
        locale = savedLocale;
      } else {
        // 判断是否开启自动识别语言
        if (Setting.i18n.auto) {
          // 如果自动识别的语言，本地没有该语言包，则设置为默认语言
          const navLang = navigator.language;
          if (state.languages[navLang]) {
            locale = navLang;
          } else {
            locale = Setting.i18n.default;
          }
        } else {
          locale = Setting.i18n.default;
        }

        // 将初次的语言保存在本地
        db.set(savedLocaleKey, locale).write();
      }
      state.locale = locale;
      vue.$i18n.locale = locale;

      // 导入 View UI Plus 语言包
      const ViewUIPlusLocale = require.context('view-design/dist/locale', false, /.+-.+.js$/);

      let res = await i18nTextApi.getAll();
      state.languages = {};

      for (let lanCode in res) {
        const currentLocale = ViewUIPlusLocale('./' + lanCode + '.js').default;

        if (currentLocale.i.locale === lanCode) {
          Object.keys(currentLocale).forEach(key => {
            res[lanCode]['text'][key] = currentLocale[key];
          });
        }

        //languages[lanCode] = res[lanCode]['text'];
        state.languages[lanCode] = res[lanCode].name;

        vue.$i18n.setLocaleMessage(lanCode, res[lanCode]['text']);
      }
    }
  }
};
